import { combineReducers } from "redux";
import userInfo from "./entities/AuthReducer";


const reducers = combineReducers({
    userInfo:userInfo
})

export default reducers;